import { Injectable } from '@angular/core';

import { ClientConfig, ClientConfigProductName, ClientConfigService } from '@frontend/vanilla/core';

export type ViewTransitionConfig = {
    deferStyleChangesTimeout: number;
    normalNavigation: ViewTransitionTimeoutConfig;
    productNavigation: ViewTransitionTimeoutConfig;
};

export type ViewTransitionTimeoutConfig = {
    contentStartTimeout: number;
    transitionDelay: number;
};

@ClientConfig({ key: 'haUi', product: ClientConfigProductName.HOST })
@Injectable({
    providedIn: 'root',
    deps: [ClientConfigService],
    useFactory: uiConfigFactory,
})
export class HostUiConfig {
    viewTransitionsEnabled: boolean;
    viewTransitionsConfig: ViewTransitionConfig;
}

export function uiConfigFactory(service: ClientConfigService) {
    return service.get(HostUiConfig);
}
